module.exports = __webpack_public_path__ + "static/media/PendingGray.8e63a596.svg";